export enum ExcelConverterEntity {
PaySlip,
PaymentOrder,
SpendingRequest,
Payroll,
PayrollSummary,
BudgetAdjustment,
TransactionEntity,
CheckNotary,
BankAccountList,
BankAccountTransactions,
Budget,
AssetDepreciations,
LeaveRequest,
CVEmployee,
EmployeeOvertime,
PeriodOvertime,
PaymentOrderPayment,
PayrollAdvance,
PayrollReport,
AdhocAdvancePayment,
EmployeeSalaryLoanInstalment,
DetailedPayrollReport,
APD,
}
